import { render, staticRenderFns } from "./ApkSafetySection.vue?vue&type=template&id=e3a4c606&scoped=true"
import script from "./ApkSafetySection.vue?vue&type=script&lang=js"
export * from "./ApkSafetySection.vue?vue&type=script&lang=js"
import style0 from "./ApkSafetySection.vue?vue&type=style&index=0&id=e3a4c606&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3a4c606",
  null
  
)

export default component.exports